export class MailingGroupEmployee {
    mailingGroupEmployeeId: number;
    mailingGroupId: number;
    reportType: number;
    employeeId: number;
    sendAnyway: boolean;
}